export type DashedOutlineStyle = {
  colour: string;
  opacity: number;
  weightPx: number;
  dashPx: number;
  repeatPx: number;
};

export const BUILDING_OUTLINE_STYLE: DashedOutlineStyle = {
  colour: '#22D3EE',
  opacity: 0.9,
  weightPx: 2.5,
  dashPx: 5,
  repeatPx: 11,
};

export const TITLE_BOUNDARY_STYLE: DashedOutlineStyle = {
  colour: '#FBBF24',
  opacity: 0.8,
  weightPx: 2,
  dashPx: 7,
  repeatPx: 14,
};

export const dashedPolylineIcons = (style: DashedOutlineStyle) => [
  {
    icon: {
      path: `M 0,${-style.dashPx / 2} 0,${style.dashPx / 2}`,
      strokeOpacity: style.opacity,
      strokeColor: style.colour,
      strokeWeight: style.weightPx,
      scale: 1,
    },
    offset: '0',
    repeat: `${style.repeatPx}px`,
  },
];

export const HIGHLIGHTED_STRING_OUTLINE_STYLE: DashedOutlineStyle = {
  colour: '#FFFFFF',
  opacity: 1,
  weightPx: 3,
  dashPx: 1,
  repeatPx: 6,
};

export const SELECTED_PANELS_OUTLINE_STYLE: DashedOutlineStyle = {
  colour: '#FFFFFF',
  opacity: 1,
  weightPx: 3,
  dashPx: 1,
  repeatPx: 1,
};
